import React, { useState, useEffect,useContext } from 'react';
import '../styles/filing.css'
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../components/dynamicicon';
import Case_Search from '../components/core/case_search';

import JisButton from '../components/controls/jisButton';

import FlowItem from '../components/controls/flowitem';
import { ShareContext } from '../context/ShareContext';

import * as Constants from '../constants';
import JisDialog from '../components/dialog';
import Gazette from '../components/core/gazette';
import BackLoader from '../components/backloader';
import Payment from '../components/core/payment';
import JisYesNo from '../components/controls/jisYesNo';

function FilingDocument() {
  const FeeTYPEID=33;
    const navigate = useNavigate()
  const { caseid } = useParams();
  
   const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
   const [cinfo, setCase] =useState(null);
   const [flow, setFlow] = useState({pos:1, code:"gazette"});
   const [flowerror, setFlowError]=useState('');
    const [casefeeId, setcasefeeId] = useState(null)
    const [parties, setParties]= useState([]);
    const [isSuccess, setIsSuccess]= useState(false);
    const [loading, setLoading] = useState(false);
    const [count,setCount]=useState(0);
    const [isLoaded, setIsLoaded]= useState(false);

       const onGazetteProceed=(e)=>{
        console.log('after processing... here is value')
        console.log(e);
        setcasefeeId(e.feeid);
        setIsSuccess(e.isPaid);
        on_gazette();
    }
        const on_gazette=()=>{
        setFlow({pos:2,code:"payment"});
    } 
       const on_payment_back=()=> setFlow({pos:1,code:"gazette"});
   
      useEffect(() => {
        if(caseid!=null){
           onLoad(caseid);
        }
                  
      }, [caseid]);
const onLoad= async(_caseid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/mini-case-details/${_caseid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCase(data.caseinfo)
                setParties(data.parties.filter(c=>c.legalCounselId==profile.id));
                setIsLoaded(true);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
  return (
    <div>

      <div style={{textAlign:'center'}}><h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo?.caseNumber}</h3>
        </div>
        <div className='multiform'>
          <div  className='flow'>
            <div className='itemgroup'>
                <FlowItem flow={flow} pos={1} code="gazette" title="Gazette" />
                <FlowItem flow={flow} pos={2} code="payment" title="Payment"  isLast={true}/>
            </div>
          </div>
          {isLoaded && flow.code=='gazette' &&  <div className='view'>
        <Gazette filingtypeid={cinfo?.caseFilingId} levelid={cinfo?.caseCategoryId}   feetypeid={FeeTYPEID}
        token={token} onProceed={(e)=>onGazetteProceed(e)} caseid={cinfo?.caseId} feeId={casefeeId}>
             <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>{cinfo?.referenceNumber} | {Constants.getItemById(frequentData.casecategories,cinfo?.caseCategoryId)?.categoryTitle}</h2>
                        
                    </div>
                    <p>Select items related to the case that you are filing</p>
                </div>
                <p className="nav-status">Suit Filing /Specifications</p>
            </div>

        </Gazette>


        </div>} 
      {isLoaded && flow.code=='payment' && <div className='view'>

        <Payment feeid={casefeeId} token={token} />
        
         <div className='flowbuttongroup'>
                        <JisButton onClick={on_payment_back}>Back</JisButton>
                       
                    </div>
        </div>} 
        </div>
    </div>
  );
}

export default FilingDocument;